export const GENERATE_BLOG = "generate_blog"
export const GENERATE_BLOG_SUCCESSFUL = "generate_blog_successfull"
export const GENERATE_BLOG_FAILED = "generate_blog_failed"
export const GET_BLOGS_PAGINATED = "get_blogs_paginated"
export const GET_BLOGS_PAGINATED_SUCCESSFUL = "get_blogs_paginated_successfull"
export const GET_BLOGS_PAGINATED_FAILED = "get_blogs_paginated_failed"
export const GET_BLOG_BY_ID = "get_blog_by_id"
export const GET_BLOG_BY_ID_SUCCESSFUL = "get_blog_by_id_successfull"
export const GET_BLOG_BY_ID_FAILED = "get_blog_by_id_failed"